/**
 * Due date vinda de /api/signature/view (objeto típico do Doctrine / Symfony).
 */
export function signatureDueDateToIso(apiDueDate) {
    if (!apiDueDate || !apiDueDate.date) {
        return null;
    }
    const d = new Date(apiDueDate.date);
    if (Number.isNaN(d.getTime())) {
        return null;
    }
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}

/** Perfil / exibição: aceita ISO YYYY-MM-DD ou string legada já formatada. */
export function formatSignatureDueDateForProfile(value) {
    if (!value) {
        return '';
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [y, m, d] = value.split('-').map(Number);
        return new Date(y, m - 1, d).toLocaleDateString();
    }
    return value;
}

/** Dias até o vencimento (calendário), mínimo 0. Null se data inválida/ausente. */
export function daysRemainingFromSignatureIso(isoDate) {
    if (!isoDate || !/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) {
        return null;
    }
    const [y, m, d] = isoDate.split('-').map(Number);
    const end = new Date(y, m - 1, d);
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    const diff = Math.round((end.getTime() - start.getTime()) / 86400000);
    return diff < 0 ? 0 : diff;
}
